/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitarRepasseAliases {
  CARD_0 = 'card-0',
  DATE_FIELD = 'date-field',
  FETCH_0 = 'fetch-0',
  FIELD_DATA_REPASSE = 'field-data-repasse',
  FIELD_LOCAL = 'field-local',
  FIELD_TOAST = 'field-toast',
  FORM_SOLICITAR_REPASSE = 'form-solicitar-repasse',
  LOCATOR_0 = 'locator-0',
  MAPPER_2 = 'mapper-2',
  PANEL_0 = 'panel-0',
  PANEL_SOLICITAR_REPASSE = 'panel-solicitar-repasse',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { SolicitarRepasseAliases };
